// /opt/isp_erp/frontend/src/components/warehouse/ConTemaBodega.jsx
import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import { temaSucursales } from "../../pages/warehouse/sucursalesTema";

/** Aplica el tema visual común a una pantalla de Bodega (no cambia su lógica). */
export default function ConTemaBodega({ children }) {
  return <ThemeProvider theme={temaSucursales}>{children}</ThemeProvider>;
}
